<template>
	<div class="result-body">
		<div class="result-content">
			<!-- <div class="fx-header">
				<p>开通微企付</p>
			</div> -->
			<div class="wei-content">
				<img src="~/images/icon/wqf-icon.png" class="wei-icon">
				<div class="wei-right">
					<div class="wei-title">微企付
						<i class="el-icon-refresh refresh-icon" @click="openPage"></i>
						<img src="~/images/icon/wqf-opening.png" style="width:60px" v-if="openStatus === 0" class="result-icon">
						<img src="~/images/icon/wqf-success.png" v-if="openStatus === 1" class="result-icon">
						<img src="~/images/icon/wqf-failed.png" v-if="openStatus === 2" class="result-icon">
					</div>
					<div class="wei-des">
						<div style="margin-right:60px">腾讯旗下支付产品，为小微企业及个体工商户提供资金收付，资金对账等服务</div>
					</div>
				</div>
			</div>
			<div class="main-table-box">
				<el-table
					class="grid-content"
					:data="tableData"
					ref='table'
					border
					stripe
				>
					<el-table-column
						prop="entId"
						label="商家ID"
						align="center">
					</el-table-column>
					<el-table-column
						prop="entName"
						label="商家全称"
						align="center">
					</el-table-column>
					<el-table-column
						prop="entAccountId"
						label="集团银行账号ID"
						align="center">
					</el-table-column>
					<el-table-column
						prop="bankCardNumberLast4"
						label="开通收款账号后四位"
						align="center">
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'tenPayResult',
	data () {
		return {
			staff: [],
			orderKey: '',
			orderBy: '',
			page: 1,
			size: 20,
			tableData: [],
			totalCount: 0,
			tabParams: {},
			totalOrderCount: 0,
			dateValue: [this.$fxUtils.getCurrentMonthFirst() + ' 00:00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59:59'],
			ids: [],
			options: [],
			showOpen: false,
			openId: '',
			openStatus: -1
		}
	},
	created () {
		let arr = window.location.href.split('/')
		this.openId = arr[arr.length - 1]
		this.openPage()
	},
	methods: {
		goOpen () {
			this.showOpen = true
		},
		dialogClose () {
			this.showOpen = false
		},
		goRecharge () {
			this.$router.push('/tenPayResult')
		},
		openPage () {
			this.$store.dispatch('requestPost', {
				url: `/quickorder/nf/v1/shop/tenpay/productapplication/status/${this.openId}`
			}).then(res => {
				if (res.result) {
					this.openStatus = res.data.status
					this.tableData = [res.data]
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		handleSizeChange (value) {
			this.size = value
			this.page = 1
			this.findOrderList()
		},
		handlePageChange (value) {
			this.page = value
			this.findOrderList()
		},
		handleSearch (data) {
			this.staff = data.staff
			this.dateValue = data.dateValue

			this.page = 1
			this.findOrderList()
		},
		sortSearch (data) {
			this.orderKey = data.orderKey
			this.orderBy = data.orderBy
			this.findOrderList()
		},
		findOrderList () {
			this.tableData = []
			let params = {
				staffIds: this.staff,
				orderKey: this.orderKey,
				orderBy: this.orderBy,
				page: this.page,
				size: this.size
			}
			if (this.dateValue.length > 0) {
				params.beginDate = this.dateValue[0]
				params.endDate = this.dateValue[1]
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/commission/commissionResultSummaryList`,
				data: params
			}).then(res => {
				this.totalCount = res.recordCount
				res.recordList.forEach(e => {
					if (!(String(e.sumcommissionmoney).indexOf('.') !== -1 && String(e.sumcommissionmoney).split('.')[1].length > 2)) {
						e.sumcommissionmoney = this.$fxUtils.toFixedSHW(e.sumcommissionmoney, 2)
					}
					if (!(String(e.commissionmoney).indexOf('.') !== -1 && String(e.commissionmoney).split('.')[1].length > 2)) {
						e.commissionmoney = this.$fxUtils.toFixedSHW(e.commissionmoney, 2)
					}
					if (!(String(e.nocommissionmoney).indexOf('.') !== -1 && String(e.nocommissionmoney).split('.')[1].length > 2)) {
						e.nocommissionmoney = this.$fxUtils.toFixedSHW(e.nocommissionmoney, 2)
					}
					e.staffname = e.staffname.split(',')
					e.name = e.staffname[e.staffname.length - 1]
				})
				this.tableData = res.recordList
			})
		},
		findUserName () {
			let params = {
				userName: ''
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlIV}/account/staff/getStaffInfoForCondition`,
				data: params
			}).then(res => {
				this.options = res.data
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.result-body {
	width: 100%;
	background-color: #fff;
	display flex
	flex-direction column
	padding: 0 10px
	.refresh-icon {
		margin-left: 5px;
		color: var(--fx-primary-color);
		cursor: pointer
	}
	.result-content {
		width: 1000px
		margin: 0 auto;
	}
	.wei-content {
		display: flex;
		padding-top: 120px;
		.wei-icon {
			width: 68px;
			height: 68px;
			flex-shrink: 0;
			margin-right: 17px
		}
		.wei-right {
			text-align: left;
			.wei-title {
				display: flex;
				align-items: center
				font-size: 14px;
				color: #595959;
				font-weight: bold
				.result-icon {
					width: 60px;
					height: 22px;
					flex-shrink: 0;
					margin-left: 17px
				}
			}
			.wei-des {
				display: flex;
				align-items: center;
				margin-top: 10px;
			}
		}
	}
	.main-table-box {
		width: 800px;
		margin-top: 20px;
	}
	.shop-position {
		display flex
		align-items: center
		height: 50px
		min-height: 50px
		font-size: 14px
		border-bottom: 1px solid #dce1fe
		img {
			display inline-block
			width: 20px
			height: 22px
			margin-right: 10px
		}
	}
	.order-menu {
		height: 50px
		display flex
		position relative
		border-bottom: 1px solid #dce1fe
		li {
			height: 100%
			line-height: 49px
			margin-right: 60px
			font-size: 15px
			// font-weight: 700
			box-sizing:border-box
			cursor: pointer
			position: relative
			color: #595959
			&.active {
				color: var(--fx-primary-color)
				border-bottom: 2px solid var(--fx-primary-color)
			}
			span {
				position: absolute;
				width: 18px;
				height: 18px;
				line-height: 18px;
				border-radius: 50%;
				font-size: 11px;
				top: 5px;
				right: -18px;
				text-align: center;
				background-color: #EC4141;
				color: #fff;
				&.big-num {
					width: 28px;
					border-radius: 40px;
					right: -28px;
				}
			}
		}
		div {
			height: 100%
			line-height: 49px
			font-size: 14px
			font-weight: 700
			box-sizing:border-box
			position absolute;
			top: 0;
			right: 50px;
		}
	}
}
</style>
<style lang="stylus">
.result-body {
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
}
</style>
